import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    tableHead: {
        backgroundColor: '#c0cbd6'
    },
    paper: {
        height: '450px'
    },
    tableContainer: {
        //padding: theme.spacing(2),
        width: '100%',
        maxHeight: 425,
    }

}));
const ReportTable = (props) => {

    const classes = useStyles();

    return (
        <div>
            <div style={{ padding: 10 }}>
                <Grid container alignItems='center'>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant='subtitle1' color='primary' style={{ fontWeight: 'bold' }}> {props.title} </Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div style={{ margin: 12, marginTop: 6 }}>
                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table aria-label="simple table" className={classes.table}>
                        <TableBody>
                            {props.reportData.map((row) => (
                                <TableRow
                                    key={row.name}>
                                    <TableCell component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row.value}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )
}

export default ReportTable;